var DataFactory = require('./lib/data-factory')

module.exports = DataFactory
